/*
 * Fast add-to-cart for the product page.
 *
 * The theme's own path costs four sequential round trips before the drawer
 * shows anything: GET /cart.js (stock pre-check) -> POST /cart/add.js ->
 * GET /cart.js -> GET /cart?view=ajax_side_cart, and the drawer only opens
 * after the third of them. On this store a single cart write is ~1s, so that
 * was ~2s to first content - then a second full pass (gift add + drawer
 * re-render) whenever the cart qualifies for the free stud.
 *
 * This path does it in one write:
 *   - the drawer opens on the click, with the theme's own loading state
 *   - /cart/add.js carries the product and, when the cart is about to qualify,
 *     the free stud in the same request, so the sync script finds nothing to do
 *   - the request asks Shopify to render sections/civia-cart-drawer.liquid in
 *     the same response (Section Rendering API), so the HTML needs no extra fetch
 *
 * Anything unusual - quick view, quick-shop popups, file-upload properties,
 * other "after add to cart" modes - is left to the theme's original handler.
 *
 * Size pickers: rings, necklaces and bracelets all render an optional size
 * picker. Until round 76 each one gated this click - Add to Cart with no size
 * opened the size sheet instead of adding - and sizeStillRequired() made this
 * handler stand aside so the gate could run. The gates were removed at the
 * client's request, so there is nothing left to stand aside for: every add is
 * handled here, with whatever size properties the form happens to carry.
 */
(function () {
  var GIFT_VARIANT_ID = 50154028728568;
  var MIN_CART_TOTAL = 149900; // $1,499.00, in cents - keep in step with layout/theme.liquid
  var SECTION_ID = 'civia-cart-drawer';
  var LOADING =
    '<div class="loading-overlay loading-overlay--custom"><div class="loading-overlay__spinner">' +
    '<svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">' +
    '<circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div></div>';

  function drawerWrapper() {
    return document.querySelector('#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper');
  }

  function canHandle(button) {
    var after = window.after_add_to_cart;
    var quick = window.quick_cart;
    if (!after || after.type !== 'quick_cart') return false;
    if (!quick || !quick.show || quick.type === 'popup') return false;
    if (document.body.matches('.quick-view-show, .quickshop-popup-show')) return false;
    if (!button.closest('product-form')) return false;
    if (button.matches('.is-notify-me, .is-soldout, .btn-unavailable, .is-loading') || button.disabled) return false;

    var form = document.querySelector('[data-type="add-to-cart-form"]');
    if (!form || !drawerWrapper()) return false;
    if (form.querySelector('input[type="file"]') || document.querySelector('.line-item-property__field input[type="file"]')) return false;
    return true;
  }

  /* The line item, the way the theme would have posted it - minus blank properties. */
  function readItem(form) {
    var item = { id: null, quantity: 1, properties: {} };
    var setProperty = function (name, value) {
      if (value != null && String(value).trim() !== '') item.properties[name] = value;
    };

    new FormData(form).forEach(function (value, key) {
      var m = /^properties\[(.+)\]$/.exec(key);
      if (key === 'id') item.id = parseInt(value, 10);
      else if (key === 'quantity') item.quantity = Math.max(1, parseInt(value, 10) || 1);
      else if (key === 'selling_plan' && value) item.selling_plan = value;
      else if (m) setProperty(m[1], value);
    });

    document.querySelectorAll('.line-item-property__field [name^="properties"]').forEach(function (field) {
      var m = /^properties\[(.+)\]$/.exec(field.name);
      if (m) setProperty(m[1], field.value);
    });

    if (!Object.keys(item.properties).length) delete item.properties;
    return item;
  }

  function variantPrice(id) {
    try {
      var v = window.ShopifyAnalytics.meta.product.variants.filter(function (x) { return x.id === id; })[0];
      return v ? v.price : null;
    } catch (e) {
      return null;
    }
  }

  /*
   * Will this add push the cart over the free-gift threshold? Decided from the
   * cart snapshot the sync script keeps, so it costs no request. If the guess is
   * wrong in either direction the sync script corrects it right after.
   */
  function giftNeeded(item) {
    var cart = window.__civiaCartSnapshot;
    if (!cart || item.id === GIFT_VARIANT_ID) return false;
    if (cart.items.some(function (i) { return i.variant_id === GIFT_VARIANT_ID; })) return false;

    var price = variantPrice(item.id);
    if (price == null) return false;

    var realTotal = cart.items
      .filter(function (i) { return i.variant_id !== GIFT_VARIANT_ID; })
      .reduce(function (sum, i) { return sum + i.original_line_price; }, 0);
    return realTotal + price * item.quantity >= MIN_CART_TOTAL;
  }

  function openDrawerLoading() {
    var wrap = drawerWrapper();
    if (wrap) {
      wrap.querySelectorAll('.civia-cart-error').forEach(function (el) { el.remove(); });
      if (!wrap.querySelector('.loading-overlay')) {
        wrap.classList.add('is-loading');
        wrap.insertAdjacentHTML('afterbegin', LOADING);
      }
    }
    document.body.classList.add('cart-sidebar-show');
  }

  function clearLoading() {
    var wrap = drawerWrapper();
    if (!wrap) return;
    wrap.classList.remove('is-loading');
    wrap.querySelectorAll('.loading-overlay').forEach(function (el) { el.remove(); });
  }

  function setCount(count) {
    var n = parseInt(count, 10);
    if (isNaN(n)) return;
    var strings = window.cartStrings || {};
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n >= 100 && strings.item_99 ? strings.item_99 : n;
    });
    document.querySelectorAll('[data-cart-text]').forEach(function (el) {
      el.textContent = n === 1 ? strings.item || '' : strings.items || '';
    });
  }

  /* innerHTML does not run <script>; the drawer's inline scripts set the stock arrays the quantity stepper reads. */
  function runInlineScripts(container) {
    container.querySelectorAll('script').forEach(function (old) {
      var s = document.createElement('script');
      s.textContent = old.textContent;
      old.parentNode.replaceChild(s, old);
    });
  }

  function renderDrawer(html) {
    var wrap = drawerWrapper();
    if (!wrap) return false;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var root = doc.querySelector('[data-cart-drawer-root]');
    if (!root) return false;

    wrap.classList.remove('is-loading');
    wrap.innerHTML = root.innerHTML;
    runInlineScripts(wrap);
    setCount(root.getAttribute('data-cart-item-count'));
    document.dispatchEvent(new CustomEvent('cart-update', { detail: { item_count: parseInt(root.getAttribute('data-cart-item-count'), 10) } }));
    return true;
  }

  /* Fall back to the theme's own renderer - it re-fetches the drawer HTML. */
  function refreshViaTheme() {
    clearLoading();
    try {
      if (window.Shopify && Shopify.getCart && window.sharedFunctions && window.sharedFunctions.updateSidebarCart) {
        Shopify.getCart(function (cart) { window.sharedFunctions.updateSidebarCart(cart); });
      }
    } catch (e) {
      console.error('Cart drawer refresh failed:', e);
    }
  }

  /* A failed add leaves the cart untouched, so the drawer content is still right; only the message is added. */
  function showError(message) {
    var wrap = drawerWrapper();
    if (!wrap) return;
    clearLoading();
    var box = document.createElement('div');
    box.className = 'civia-cart-error';
    box.setAttribute('role', 'alert');
    box.textContent = message;
    wrap.querySelectorAll('.civia-cart-error').forEach(function (el) { el.remove(); });
    wrap.insertAdjacentElement('afterbegin', box);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-btn-addtocart]');
    if (!button || !canHandle(button)) return;

    // Capture phase + stopImmediatePropagation: the theme's delegated jQuery
    // handler on document never sees this click.
    event.preventDefault();
    event.stopImmediatePropagation();

    var form = document.querySelector('[data-type="add-to-cart-form"]');
    var item = readItem(form);
    if (!item.id) return;

    var items = [item];
    if (giftNeeded(item)) items.push({ id: GIFT_VARIANT_ID, quantity: 1, properties: { _free_gift: 'true' } });

    button.classList.add('is-loading');
    openDrawerLoading();

    fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items, sections: SECTION_ID, sections_url: window.location.pathname })
    })
      .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
      .then(function (result) {
        if (!result.ok) {
          showError(result.data.description || result.data.message || 'Sorry, that could not be added to your cart.');
          return;
        }
        var html = result.data.sections && result.data.sections[SECTION_ID];
        if (!html || !renderDrawer(html)) refreshViaTheme();
      })
      .catch(function (error) {
        console.error('Add to cart failed:', error);
        showError('Something went wrong. Please try again.');
      })
      .then(function () {
        button.classList.remove('is-loading');
      });
  }, true);
})();
